import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const airbnb: GetCustomerCopyFunc = () => {
  return {
    countriesToHideWorkLifeServicesFor: ['United Kingdom', 'Ireland'],
  }
}
